module.exports = __webpack_public_path__ + "static/media/background.6687d928.jpg";